export default class SummaryBlockController {
    static $inject = ['$scope'];
    constructor($scope) {
        this.$scope = $scope;
    }

    $onInit() {
        this.calculateClasses(this.model);
        const classes = [ this.positioning ];
        if (this.clickable) {
            classes.push('clickable');
        }
        if (this.positioning === 'vertical') {
            classes.push('center-block');
        }
        this.viewClass = classes.join(' ');
        this.unwatch = this.$scope.$watch(() => this.model, (newValue, oldValue) => {
            if (newValue) {
                this.calculateClasses(newValue);
            }
        }, true);
    }

    $onDestroy() {
        this.unwatch();
    }

    cut(value) {
        if (value === undefined) {
            return;
        }
        const strValue = value.toString();
        const limit = strValue.indexOf('.') === -1 ? 5 : 4;
        return strValue.length > limit ? `${strValue.substring(0, limit)}` : strValue;
    }

    calculateDiff(diffValue, model){
        return model.previousValue == 0
            ? this.cut(diffValue)
            : this.cut(((model.currentValue - model.previousValue) / model.previousValue) * 100);
    }

    calculateClasses(model) {
        const diffObj = this.getDiffAsObject(model.currentValue, model.previousValue, model.isPositive);
        this.diffClass = diffObj.diffClass;
        this.arrowClass = diffObj.arrowClass;
        this.colorClass = diffObj.colorClass;
        const diffValue = Math.abs(model.diff);
        const currentValue = Math.abs(model.currentValue);
        const previousValue = Math.abs(model.previousValue);
        this.clearValues = {
            diff: `${diffObj.sign}${diffValue}${model.currentValue - model.previousValue === model.diff || model.previousValue == 0 ? '' : '%'}`,
            previous: `${previousValue}`,
            current: `${currentValue}`
        };
        this.parsedValues = {
            diff: `${diffObj.sign}${Math.abs(this.calculateDiff(diffValue, model))}${model.previousValue === 0 ? '' : '%'}`,
            diffValue: `(${model.previousValue !=0 ? '':diffObj.sign}${this.cut(diffValue)})`,
            previous: `(${this.cut(previousValue)})`,
            previousValue:previousValue,
            current: `${this.cut(currentValue)}`
        };
    }

    click() {
        if (this.onClick && this.clickable) {
            this.onClick();
        }
    }

    getViewClass() {
        return this.viewClass;
    }

    getDiffAsObject(current, previous, isPositive) {
        if (current === previous) {
            return {
                sign: '',
                diffClass: 'even',
                arrowClass: '',
                colorClass: ''
            };
        }

        return current > previous ? {
            diffClass: 'up',
            sign: '+',
            arrowClass: isPositive ? 'up green' : 'up red',
            colorClass: isPositive ? 'positive' : 'negative'
        } : {
            diffClass: 'down',
            sign: '-',
            arrowClass: isPositive ? 'down red' : 'down green',
            colorClass: isPositive ? 'negative' : 'positive'
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/summary-block/summary-block.controller.js